<template>
  <div>

    <Row style="border-left: 5px solid #009688;margin-bottom: 5px">
      <Col span="4">订单数量: <Tag color="error">{{countData.order_num}} </Tag></Col>
      <Col span="4">销售额: <Tag color="error">{{countData.total_price}} 元</Tag></Col>
      <Col span="4">待结算金额: <Tag color="error">{{countData.wait_settlement_amount}} 元</Tag></Col>
      <Col span="4">销售量: <Tag color="error">{{countData.litre_num}} 升</Tag></Col>
    </Row>
    <pageTable ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               :doneFunction="doneFunction"
               tableApi="admin/order/getSettleOrder"
               :onSelectChange="selectionChange"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="mobile">
          <Input type="text" v-model="searchData.mobile" placeholder="手机号" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="station_id">
          <FormItem prop="station_id">
            <Select v-model="searchData.station_id" :filterable="true">
              <Option v-for="(item,key) in stations" :value="item.id">{{item.name}}</Option>
            </Select>
          </FormItem>
        </FormItem>
        <FormItem prop="is_settle">
          <Select v-model="searchData.is_settle">
            <Option value="0">待结算</Option>
            <Option value="1">已结算</Option>
          </Select>
        </FormItem>
        <FormItem prop="company_id">
          <Select v-model="searchData.company_id" placeholder="选择车队" :filterable="true">
            <Option value="">所有车队</Option>
            <Option v-for="item in companys" :value="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem prop="create_time">
          <DatePicker v-model="searchData.create_time" type="datetimerange" @on-change="timeChange" placeholder="购买时间" style="width: 320px"></DatePicker>
        </FormItem>
      </template>

      <template v-slot:otherBtn>
        <FormItem>
          <Button type="primary" icon="ios-paper-plane-outline" @click="showMutSettle=true">批量结算</Button>
        </FormItem>
      </template>
    </pageTable>

    <userEditForm v-if="showUserDetail"
                  :show-edit="showUserDetail"
                  :user_id="editUserId"
                  ref="editModel"
                  @cancel-edit="showUserDetail=false"
    >
    </userEditForm>

    <!--<orderDetail v-if="showOrderDetail"
                  :show-edit="showOrderDetail"
                  :order_id="editOrderId"
                  ref="orderDetail"
                  @cancel-edit="showOrderDetail=false"
    >
    </orderDetail>-->

    <doSettle v-if="showSettleDetail"
                 :show-edit="showSettleDetail"
                 :order_id="settleOrderId"
                 ref="settleDetail"
                @cancel-edit="closeSettleDetail"
              @settle-success="settleSuccess"
    >
    </doSettle>

    <Drawer title="结账详情" width="900" :value="settleRecord.isShow"
            :mask-closable="true"
            @on-close="closeSettleRecord">
      <settleDetail v-if="settleRecord.isShow"
              :id="settleRecord.order_id">
      </settleDetail>
    </Drawer>

    <Drawer title="批量结算" width="600" :value="showMutSettle"
            :mask-closable="true"
            @on-close="showMutSettle=false">
      <mutSettle v-if="showMutSettle"
                    :ids="selectedID"
                 :settleAmount="selectedAmount"
      >
      </mutSettle>
    </Drawer>

  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import userEditForm from "../user/edit";
  import orderDetail from "./detail";
  import doSettle from "./doSettle";
  import settleDetail from "./settleDetail";
  import XLSX from 'xlsx'
  import mutSettle from "./mutSettle";

  export default {
    name: "lists",
    components:{pageTable,userEditForm,orderDetail,doSettle,settleDetail,mutSettle},
    data() {
      return {
        editUserId:0,     //编辑的ID
        showUserDetail:false,
        editOrderId:0,     //编辑的ID
        showOrderDetail:false,
        showSettleDetail:false,
        settleOrderId:0,
        settleRecord:{
          isShow:false,
          order_id:0,
        },
        searchData: {
          mobile: '',
          nick_name:'',
          car_number:'',
          create_time:'',
          gas_name:'',
          export_type:'ty',
          settleIds:[],
          is_settle:'0',
          company_id:''
        },
        tableColumn: [
          { type: 'selection', width: 60, align: 'center'},
          {title:'车队',key:'company_name',align:'center'},
          {title:'司机',key:'driver_name',align:'center'},
          /*{title: '用户',key: 'mobile',align: "center",render:(h,params)=>{
              return h('a',{on:{click:()=>{this.showUserDetailPage(params.row.user_id)}}},params.row.mobile || params.row.nick_name)
            }},*/
          {title:'油站',key:'gas_name',align:'center'},
          {title:'升数',key:'litre_num',align:'center'},
          // {title:'油号',key:'oil_no_name',align:'center'},
          {title:'销售金额',key:'total_price',align:'center'},
          {title:'结算总额',key:'settlement_amount',align:'center'},
          {title:'已结算金额',key:'settled_amount',align:'center'},
          {title:'待结算金额',key:'wait_settle_amount',align:'center'},
          {title:'结算状态',align:'center',render:(h,params)=>{
            return h('span',parseInt(params.row.is_settle) === 1 ? '已结算' : '待结算')
            }},
          {title:'下单时间',key:'create_time',align:'center',width:170},
          {title:'结算',align:'center',width:180,render:(h,params)=>{
            let is_settle = parseInt(params.row.is_settle);
              let content=[];
              if (is_settle === 0){
                content.push(h('Button',{
                  props: {type: 'primary', size: 'small',},
                  style: {marginLeft: '5px'},
                  on: {click: () => {this.showSettle(params.row.order_id)}
                  }
                },'结算'))
              }
              content.push(h('Button',{
                props: {type: 'primary', size: 'small',},
                style: {marginLeft: '5px'},
                on: {click: () => {this.showSettleRecord(params.row.order_id)}
                }
              },'结算记录'))

              return h('div',content)
            }},
        ],
        tableData: [],
        countData:{},
        stations:[],
        companys:[],
        selectedID:[],
        selectedAmount:0,
        showMutSettle:false,
      }
    },
    methods: {
      showDetail(order_id){
        this.editOrderId = order_id
        this.showOrderDetail = true
      },
      showUserDetailPage(user_id){
        this.showUserDetail = true
        this.editUserId = user_id
      },
      reloadDetail(user_id){
        this.showUserDetail = false
        this.$nextTick(()=>{
          this.showUserDetailPage(user_id)
        })
      },
      showSettle(order_id){
        this.showSettleDetail = true;
        this.settleOrderId = order_id;
      },
      closeSettleDetail(){
        this.showSettleDetail = false;
        this.settleOrderId = 0;
      },
      settleSuccess(){
        this.$refs.table.getLists();
        this.showSettleDetail = false;
        this.settleOrderId = 0;
      },
      mutSuccess(){
        console.log(111)
        this.$refs.table.getLists();
        this.selectedAmount = 0;
        this.selectedID = [];
        this.showMutSettle = false;
      },
      showSettleRecord(order_id){
        this.settleRecord.isShow = true
        this.settleRecord.order_id=order_id
      },
      closeSettleRecord(){
        this.settleRecord.isShow = false
        this.settleRecord.order_id = 0
      },
      doneFunction(res){
        this.countData = res.extra
      },
      selectionChange(selected){
        let ids = [],total_amount = 0;
        selected.forEach(val=>{
          ids.push(val.order_id)
          total_amount += val.settlement_amount
        })
        this.selectedID = ids
        this.selectedAmount = total_amount
      },
      async doSettle(order_id,settle_id){
        this.$Modal.confirm({
          title:'订单结算',
          content:'确定要提交吗？',
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/settlement/doSettle',{order_id,settle_id});
            this.$Modal.remove()
            this.$commonFun.dealApiResult(res,()=>{
              this.$refs.table.getLists();
              this.$commonFun.successTip(res.msg)
            })
          }
        })
      },
      settleMut(){
        this.showMutSettle=true
      },
      async doSettleMut(){

      },
      timeChange(time) {
        console.log(time)
        if(time[1].slice(-8)==='00:00:00'){
          time[1] = time[1].slice(0,-8) + '23:59:59'
          this.searchData.create_time = time
        }
      },
    },
    mounted() {
      this.$commonFun.postProxy('admin/common/getPageInitInfo',{type:['oil_station','companys']}).then((res)=>{
        this.stations = res.data.oil_station
        this.companys = res.data.companys
      })
    },
  }
</script>

<style scoped>

</style>
